import { functions } from '../firebase';

export const fetchBillingDetails = async (organizationId, studentId) => {
  const params = { organizationId, studentId };

  const data = await functions().httpsCallable('callables-students-getBillingDetails')(params);

  return { ...data, studentId };
};
